export const membershipPlans = [
  {
    name: "1 Week",
    duration: "7 days",
    upfrontPrice: 99,
    benefits: [
      "Priority booking support",
      "10% cashback on eligible completed orders",
      "Member-only promo code access",
    ],
  },
  {
    name: "1 Month",
    duration: "30 days",
    upfrontPrice: 299,
    benefits: [
      "Priority booking support",
      "10% cashback on eligible completed orders",
      "Better protection against surge pricing",
      "Member-only promo code access",
    ],
  },
  {
    name: "3 Months",
    duration: "90 days",
    upfrontPrice: 699,
    benefits: [
      "Higher booking priority",
      "10% cashback on eligible completed orders",
      "Better surge control on selected services",
      "Member-only promo code access",
    ],
  },
  {
    name: "6 Months",
    duration: "180 days",
    upfrontPrice: 1199,
    benefits: [
      "Higher booking priority",
      "10% cashback on eligible completed orders",
      "Preferential pricing support on repeat usage",
      "Member-only promo code access",
    ],
  },
  {
    name: "1 Year",
    duration: "365 days",
    upfrontPrice: 1999,
    benefits: [
      "Highest booking priority",
      "10% cashback on eligible completed orders",
      "Exclusive member-only promo code access",
    ],
  },
];

export function findMembershipPlanByName(planName) {
  return membershipPlans.find((plan) => plan.name === planName) || null;
}

export function getMembershipCashbackRate() {
  return 0.1;
}
